import React from "react"
import styled from "styled-components"

import { Box, Flex } from "components/box"
import { Paragraph, ParagraphLarge, Link } from "components/text"

import { baseRoutes } from "routes"

const NotificationContainer = styled(Box).attrs({
  p: [4, 4, 5, 5],
  mt: [4, 4, 6, 6],
  mb: [5, 5, 7, 7],
  color: "evergreen",
  bg: "sandy"
})`
  text-align: center;
  background-color: ${props => props.theme.colors.white};
  border-radius: 8px;
  border: solid 2px ${props => props.theme.colors.sandy};
  color: ${props => props.theme.colors.evergreen};
`

const NotificationLinkContainer = styled(Link)`
  :hover {
    opacity: 1;
  }
`

type NotificationProps = {
  title: React.ReactNode
  description: React.ReactNode
  dataTest?: string
  to?: Maybe<string>
  placeOrderButton?: React.ReactNode
}

const NotificationCard: React.FC<NotificationProps> = ({ title, description, dataTest, placeOrderButton }) => (
  <NotificationContainer data-test={dataTest}>
    <ParagraphLarge mb={3} bold>
      {title}
    </ParagraphLarge>
    <Paragraph>{description}</Paragraph>
    {placeOrderButton && (
      <>
        <Flex justifyContent="center" pt={5}>
          {placeOrderButton}
        </Flex>
        <Paragraph pt={5} color="seafoamBlue" bold>
          <Link to={baseRoutes.doctorMessaging()} underline>
            Message doctor
          </Link>
        </Paragraph>
      </>
    )}
  </NotificationContainer>
)

export const Notification: React.FC<NotificationProps> = ({ to, ...notificationProps }) =>
  to ? (
    <NotificationLinkContainer to={to}>
      <NotificationCard {...notificationProps} />
    </NotificationLinkContainer>
  ) : (
    <NotificationCard {...notificationProps} />
  )

export default Notification
